import { useCsvState, useCsvDispatch, save as _save, undo as _undo, redo as _redo } from './csvContext';

function useCsvEditor() {
  var documentState = useCsvState();
  var documentDispatch = useCsvDispatch();
  var dirty = documentState && Object.keys(documentState.csvData).some(function (key) {
    return documentState.csvData[key].edits !== null;
  });
  return {
    save: function save() {
      _save(documentDispatch, documentState);
    },
    isSaving: documentState && documentState.isSaving,
    canSave: documentState && dirty && !documentState.isSaving,
    undo: function undo() {
      return _undo(documentDispatch);
    },
    canUndo: documentState && documentState.undoStates.length > 0,
    redo: function redo() {
      return _redo(documentDispatch);
    },
    canRedo: documentState && documentState.redoStates.length > 0
  };
}

export default useCsvEditor;